/* Vista comercial. Misma interfaz que el Helper; no habla con Premiere. */
(() => {
  const params = new URLSearchParams(location.search);
  const asked = (params.get("plataforma") || params.get("platform") || "mac").toLowerCase();
  const platform = asked.startsWith("win") ? "windows" : "mac";
  const isEquinox = /\/equinox(\/|$)/.test(location.pathname) || /\/pages\/equinox/.test(location.pathname);
  const pages = {
    absolute: (window.EQUINOX_DEMO_PAGES&&window.EQUINOX_DEMO_PAGES.absolute)||"/pages/absolute",
    glyph: (window.EQUINOX_DEMO_PAGES&&window.EQUINOX_DEMO_PAGES.glyph)||"/pages/glyph",
    curvesmith: (window.EQUINOX_DEMO_PAGES&&window.EQUINOX_DEMO_PAGES.curvesmith)||"/pages/curvesmith",
    obsidian: (window.EQUINOX_DEMO_PAGES&&window.EQUINOX_DEMO_PAGES.obsidian)||"/pages/obsidian",
    firekeeper: (window.EQUINOX_DEMO_PAGES&&window.EQUINOX_DEMO_PAGES.relay)||"/pages/relay",
    notes: (window.EQUINOX_DEMO_PAGES&&window.EQUINOX_DEMO_PAGES.notes)||"/pages/notes",
  };

  if (platform === "windows") {
    window.EquinoxWindows = {
      platform: "win32",
      host: "comercial",
      shell: "windows-11-dark",
    };
    document.documentElement.classList.add("equinox-windows-host");
    document.documentElement.classList.add("equinox-comercial-embed");
  } else {
    document.documentElement.classList.add("equinox-comercial-mac");
    document.documentElement.classList.add("equinox-comercial-embed");
  }


  function pinComercialEmbed() {
    if (document.getElementById("equinox-comercial-embed-css")) return;
    const link = document.createElement("link");
    link.id = "equinox-comercial-embed-css";
    link.rel = "stylesheet";
    link.href = window.EQUINOX_ASSET("_host/comercial-embed.css");
    document.head.append(link);
  }

  function withPlatform(href) {
    const url = new URL(href, location.href);
    url.searchParams.set("plataforma", platform);
    return url.href;
  }

  function showToast(message) {
    let node = document.getElementById("comercial-toast");
    if (!node) {
      node = document.createElement("div");
      node.id = "comercial-toast";
      document.body.append(node);
    }
    node.textContent = message;
    node.classList.add("is-on");
    clearTimeout(showToast.timer);
    showToast.timer = setTimeout(() => node.classList.remove("is-on"), 2600);
  }

  const labels = [
    ["Violet", "#3E0AAE"], ["Iris", "#004B67"], ["Caribbean", "#2A5507"], ["Lavender", "#751187"],
    ["Cerulean", "#05555B"], ["Forest", "#3D4A00"], ["Rose", "#8C0235"], ["Mango", "#893A04"],
    ["Purple", "#6100B7"], ["Blue", "#122D9A"], ["Teal", "#014E45"], ["Magenta", "#840D58"],
    ["Tan", "#6F5A45"], ["Green", "#0D5D27"], ["Brown", "#5D3B06"], ["Yellow", "#6F6619"],
  ].map(([name, color], index) => ({ index, name, color }));

  function extraAbsolute() {
    const items = window.EQUINOX_OPCIONES?.absolute;
    if (!Array.isArray(items)) return [];
    return items.filter((item) => item && item.name).map((item, index) => ({
      id: item.id || `pagina:${index}`,
      name: item.name,
      category: item.category || "video-effects",
      searchText: item.searchText || item.name,
      preset: item.category === "user-presets",
    }));
  }

  const absoluteCatalog = [
    { id: "fx:gaussian", name: "Gaussian Blur", category: "video-effects", searchText: "gaussian blur desenfoque gaussiano" },
    { id: "fx:transform", name: "Transform", category: "video-effects", searchText: "transform transformar position scale anchor" },
    { id: "fx:opacity", name: "Opacity", category: "video-effects", searchText: "opacity opacidad" },
    { id: "fx:lumetri", name: "Lumetri Color", category: "video-effects", searchText: "lumetri color" },
    { id: "fx:volume", name: "Volume", category: "audio-effects", searchText: "volume volumen audio" },
    { id: "fx:fill", name: "Fill Frame", category: "video-effects", searchText: "fill frame rellenar encuadre" },
    { id: "preset:bottom-left", name: "Bottom Left", category: "user-presets", preset: true, searchText: "bottom left preset" },
    { id: "preset:slide", name: "Deslizar de derecha (slow)", category: "user-presets", preset: true, searchText: "deslizar derecha slide preset" },
    { id: "artorias:label", name: "Label", category: "video-effects", heroAction: "labelPicker", searchText: "label etiqueta labels color" },
  ];

  function swatch(hex, title) {
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="640" height="360"><rect width="100%" height="100%" fill="#120c1e"/><rect x="36" y="250" width="180" height="8" fill="${hex}"/><text x="36" y="210" fill="${hex}" font-family="Inter,sans-serif" font-size="54" font-weight="650">${title}</text></svg>`;
    return `data:image/svg+xml,${encodeURIComponent(svg)}`;
  }

  // Títulos reales de Juan (Clashiv titles) — demos; packs en clashivfx.com
  const obsidianTemplates = [
    { identity: "clashi-blue-orange", name: "BLUE AND ORANGE", library: "Clashi", previewURL: window.EQUINOX_ASSET("_host/capturas/blue-and-orange.svg") },
    { identity: "clashi-blur-in", name: "BLUR IN", library: "Clashi", previewURL: window.EQUINOX_ASSET("_host/capturas/blur-in.svg") },
    { identity: "clashi-bottom-in", name: "BOTTOM IN", library: "Clashi", previewURL: window.EQUINOX_ASSET("_host/capturas/bottom-in.svg") },
    { identity: "clashi-bubble", name: "Bubble", library: "Clashi", previewURL: window.EQUINOX_ASSET("_host/capturas/bubble.svg") },
    { identity: "clashi-clean-aes", name: "clean aesthetic light", library: "Clashi", previewURL: window.EQUINOX_ASSET("_host/capturas/clean-aesthetic.svg") },
    { identity: "clashi-clean-blue", name: "CLEAN BLUE", library: "Clashi", previewURL: window.EQUINOX_ASSET("_host/capturas/clean-blue.svg") },
  ];
  const obsidianFavs = new Set(["clashi-blur-in"]);

  const glyphTracks = [
    { label: "V1", trackID: "V1", lockState: "unlocked", status: "available", fits: 8, total: 8 },
    { label: "V2", trackID: "V2", lockState: "unlocked", status: "available", fits: 8, total: 8 },
    { label: "V3", trackID: "V3", lockState: "locked", status: "blocked", fits: 2, total: 8 },
    { label: "V4", trackID: "V4", lockState: "unlocked", status: "partial", fits: 5, total: 8 },
    { label: "V5", trackID: "V5", lockState: "unlocked", status: "available", fits: 8, total: 8 },
    { label: "V6", trackID: "V6", lockState: "unlocked", status: "available", fits: 8, total: 8 },
  ];

  const equinoxState = {
    equinoxVersion: "0.5.0",
    artoriasVersion: "0.2.0",
    namelessKingVersion: "0.1.0",
    engineStatus: "Helper online · Premiere running",
    premiereRunning: true,
    selectedThemeID: "equinox.purple",
    themes: [
      { id: "equinox.purple", name: "Purple" },
      { id: "equinox.blue", name: "Blue" },
      { id: "equinox.pearl", name: "Pearl" },
      { id: "equinox.default", name: "Equinox" },
    ],
    availableModules: { absolute: true, glyph: true, curvesmith: true, obsidian: true, firekeeper: false },
    shortcuts: {
      equinox: "⌥E",
      summon: "⌥Space",
      adjustment: "⌥A",
      matte: "⌥M",
      transparent: "⌥T",
      "nameless-king": "⌥G",
    },
    licensingEnforcement: false,
    licensePanel: { retailBuild: false },
  };

  let absoluteSeeded = false;
  let glyphSeeded = false;
  let obsidianSeeded = false;
  let equinoxSeeded = false;
  let notesSeeded = false;
  const queued = [];

  function seedAbsolute() {
    if (absoluteSeeded || !window.Artorias?.setCatalog) return false;
    absoluteSeeded = true;
    window.Artorias.receiveState({
      engineConnected: true,
      premiereRunning: true,
      httpListening: true,
      engineStateLabel: "Connected",
      limitedMode: false,
    });
    window.Artorias.setCatalog([...absoluteCatalog, ...extraAbsolute()]);
    window.Artorias.setLabelPalette(labels);
    return true;
  }

  function seedGlyph() {
    if (!window.NamelessKingHero?.setTimelinePreview) return false;
    glyphSeeded = true;
    window.NamelessKingHero.setTimelinePreview({
      state: "ready",
      selectionCount: 8,
      tracks: glyphTracks,
    });
    return true;
  }

  function glyphPlan(trackID) {
    if (!window.NamelessKingHero?.setPlacementPlan) return false;
    const track = glyphTracks.find((item) => item.trackID === trackID) || glyphTracks[1];
    const auto = !trackID || trackID === "AUTO";
    window.NamelessKingHero.setPlacementPlan({
      accepted: true,
      mode: auto ? "auto" : "explicit",
      trackID: track.trackID,
      label: track.label,
      lockState: track.lockState,
      status: track.status === "blocked" ? "available" : track.status,
      fits: track.fits,
      total: track.total,
      state: "ready",
      planID: `preview-${track.trackID}`,
    });
    return true;
  }

  function seedObsidian() {
    if (obsidianSeeded || !window.ConsoleTitles?.setCatalog) return false;
    obsidianSeeded = true;
    window.ConsoleTitles.setFonts([
      { family: "Archivo", postscript: "Archivo-Regular" },
      { family: "Archivo", postscript: "Archivo-SemiBold" },
    ]);
    window.ConsoleTitles.setIndexing?.("Clashi · títulos de tu librería · packs en clashivfx.com");
    window.ConsoleTitles.setCatalog(obsidianTemplates, [...obsidianFavs]);
    return true;
  }

  function mountExtraAddons() {
    const list = document.getElementById("my-addons-list");
    const items = window.EQUINOX_OPCIONES?.equinox;
    if (!list || !Array.isArray(items)) return;
    for (const item of items) {
      if (!item?.name || document.querySelector(`[data-addon-id="${item.id}"]`)) continue;
      const article = document.createElement("article");
      article.className = "module product-row is-openable";
      article.dataset.addonId = item.id || item.name;
      article.innerHTML = `
        <div class="module-row">
          <div>
            <h3></h3>
            <p></p>
            <div class="product-meta"><span class="tag ready">Página comercial</span></div>
          </div>
          <div class="product-actions">
            <span class="tag">${item.version || "—"}</span>
            <button class="tag action" type="button">Open</button>
          </div>
        </div>`;
      article.querySelector("h3").textContent = item.name;
      article.querySelector("p").textContent = item.description || "Opción agregada para la página.";
      const open = () => {
        if (item.href) location.href = withPlatform(item.href);
        else showToast(`${item.name}: opción de la página. Poné href en _host/opciones.js para abrir una pantalla.`);
      };
      article.querySelector("button").onclick = (event) => {
        event.stopPropagation();
        open();
      };
      if (platform !== "windows") article.onclick = open;
      list.append(article);
    }
  }

  function seedEquinox() {
    if (equinoxSeeded || !window.EquinoxNative?.receiveState) return false;
    equinoxSeeded = true;
    window.EquinoxNative.receiveState(equinoxState);
    mountExtraAddons();
    return true;
  }

  function onEquinox(type, msg) {
    if (type === "ready") return seedEquinox();
    if (type === "refreshState" || type === "windowDrag" || type === "preset.list") return true;
    if (type === "selectTheme") {
      equinoxState.selectedThemeID = msg.themeID || equinoxState.selectedThemeID;
      document.documentElement.setAttribute("data-theme-id", equinoxState.selectedThemeID);
      window.EquinoxNative?.receiveState(equinoxState);
      return true;
    }
    if (type === "openAddon") {
      const href = pages[msg.addonID];
      if (href) location.href = withPlatform(href);
      else window.EquinoxNative?.showNotice("Esa opción no tiene pantalla en esta carpeta.");
      return true;
    }
    if (type === "openShop") {
      showToast("Shop: en el producto abre la página de compra.");
      return true;
    }
    if (type === "close") {
      if (document.referrer) history.back();
      else location.href = "/";
      return true;
    }
    if (type === "licenseActivate" || type === "licenseDeactivate") {
      window.EquinoxNative?.showNotice("Vista previa. La licencia real la resuelve el Helper.");
      return true;
    }
    if (String(type || "").startsWith("preset.") || type === "checkUpdates" || type === "shortcutCaptureStart") {
      return true;
    }
    return true;
  }

  function onAbsolute(type, msg) {
    if (type === "ready" || type === "catalogReceived") return seedAbsolute() || !!window.Artorias;
    if (type === "openConsoleTitles") {
      location.href = withPlatform(pages.obsidian);
      return true;
    }
    if (type === "openNotes") {
      location.href = withPlatform(pages.notes);
      return true;
    }
    if (type === "openPanel" && msg.panel === "bezier") {
      location.href = withPlatform(pages.curvesmith);
      return true;
    }
    if (type === "executeCatalog") {
      window.Artorias?.showNotice(`Vista previa. En Premiere, Absolute aplica «${msg.item?.name || "el comando"}».`);
      return true;
    }
    if (type === "quickAction") {
      const kind = msg.kind === "color" ? `Color Matte ${msg.color || ""}` : msg.kind;
      window.Artorias?.showNotice(`Vista previa. En Premiere se inserta ${kind}.`);
      return true;
    }
    if (type === "timeInfo") {
      window.Artorias?.showTimeInfo({
        selection: { display: "00:00:04:12", human: "4 segundos 12 frames" },
        inOut: { display: "00:00:10:00", human: "10 segundos" },
      });
      return true;
    }
    return true;
  }

  function onGlyph(type, msg) {
    if (!window.NamelessKingHero) return false;
    if (type === "ready" || type === "refreshPreview") {
      seedGlyph();
      return true;
    }
    if (type === "autoPlan" || type === "chooseTrack") {
      glyphPlan(msg.trackID);
      return true;
    }
    if (type === "convertCaptions") {
      window.NamelessKingHero.finishConversion({
        created: 8,
        message: "Vista previa: 8 graphics. En Premiere esto baja los captions.",
      });
      return true;
    }
    return true;
  }

  function obsidianProperties(identity) {
    const item = obsidianTemplates.find((entry) => entry.identity === identity);
    return {
      identity,
      live: false,
      properties: [
        { id: "line1", name: "Line 1", section: "Text", kind: "text", editable: true, value: item?.name || "Title" },
        { id: "line2", name: "Line 2", section: "Text", kind: "text", editable: true, value: "Subtitle" },
        { id: "size", name: "Size", section: "Text", kind: "number", editable: true, minimum: 8, maximum: 400, value: 64 },
        { id: "fill", name: "Fill", section: "Style", kind: "color", editable: true, hostValue: "[0.85,0.78,1,1]" },
        { id: "shadow", name: "Shadow", section: "Style", kind: "boolean", editable: true, value: true },
      ],
    };
  }

  function onNotes(type) {
    if (type === "ready") {
      if (notesSeeded) return true;
      if (!window.AbsoluteNotes?.loadState) return false;
      notesSeeded = true;
      window.AbsoluteNotes.loadState({
        version: 3,
        active: "n1",
        pinned: false,
        minimized: false,
        tabs: [{
          id: "n1",
          title: "Project notes",
          html: "<p>Nota de rodaje. Se puede escribir, poner negrita y sumar pestañas.</p>",
          lang: "es",
          color: "yellow",
        }],
        trash: [],
      });
      return true;
    }
    if (type === "save") {
      window.AbsoluteNotes?.saved();
      return true;
    }
    if (type === "close") {
      showToast("En el producto esto cierra Notes.");
      return true;
    }
    return true;
  }

  function onObsidian(type, msg) {
    if (!window.ConsoleTitles) return false;
    if (type === "ready" || type === "indexing") return seedObsidian() || true;
    if (type === "edit") {
      window.ConsoleTitles.receiveProperties(obsidianProperties(msg.identity));
      return true;
    }
    if (type === "favorite") {
      if (obsidianFavs.has(msg.identity)) obsidianFavs.delete(msg.identity);
      else obsidianFavs.add(msg.identity);
      window.ConsoleTitles.setFavorite({ identity: msg.identity, favorite: obsidianFavs.has(msg.identity) });
      return true;
    }
    if (type === "add") {
      window.ConsoleTitles.receiveInsert({
        success: true,
        identity: msg.identity,
        message: "Vista previa Clashi · en Premiere entra el .mogrt. Packs reales: clashivfx.com",
      });
      return true;
    }
    if (type === "update") {
      window.ConsoleTitles.receiveUpdate({
        success: true,
        identity: msg.identity,
        requestId: msg.requestId,
        values: msg.values || [],
      });
      return true;
    }
    if (type === "refresh" || type === "import") {
      showToast("Vista previa. El catálogo de muestra ya está en pantalla.");
      return true;
    }
    return true;
  }

  function dispatch(handlerName, msg) {
    const type = msg?.type || "";
    if (handlerName === "equinox" || handlerName === "darkSignal") return onEquinox(type, msg);
    if (handlerName === "artorias") return onAbsolute(type, msg);
    if (handlerName === "namelessKing" || handlerName === "nameless-king") return onGlyph(type, msg);
    if (handlerName === "consoleTitles") return onObsidian(type, msg);
    if (handlerName === "absoluteNotes") return onNotes(type);
    return true;
  }

  function postMessage(handlerName, msg) {
    if (dispatch(handlerName, msg) === false) queued.push([handlerName, msg]);
  }

  const handlerNames = ["equinox", "darkSignal", "artorias", "namelessKing", "nameless-king", "consoleTitles", "absoluteNotes"];
  window.webkit = window.webkit || {};
  window.webkit.messageHandlers = window.webkit.messageHandlers || {};
  for (const name of handlerNames) {
    if (!window.webkit.messageHandlers[name]) {
      window.webkit.messageHandlers[name] = {
        postMessage: (msg) => postMessage(name, msg),
      };
    }
  }

  function mountChrome() {
    const style = document.createElement("style");
    style.id = "equinox-comercial-stage";
    style.textContent = `
      #comercial-toast{position:fixed;left:50%;bottom:16px;z-index:80;max-width:min(520px,92vw);
        transform:translateX(-50%) translateY(8px);opacity:0;pointer-events:none;
        padding:10px 14px;border-radius:999px;border:1px solid rgba(255,255,255,.16);
        background:rgba(16,10,28,.92);color:#f4f1ff;font:13px/1.35 Inter,system-ui,sans-serif;
        box-shadow:0 12px 30px rgba(0,0,0,.35);transition:opacity .18s ease,transform .18s ease}
      #comercial-toast.is-on{opacity:1;transform:translateX(-50%) translateY(0)}
      html.equinox-comercial-mac,html.equinox-comercial-mac body{
        background:
          radial-gradient(55% 70% at 12% 10%, rgba(99,91,255,.20) 0%, transparent 60%),
          radial-gradient(40% 60% at 88% 14%, rgba(193,123,255,.13) 0%, transparent 56%),
          linear-gradient(135deg,#07060f,#0d0a18 42%,#141126 100%) !important;
        background-color:#07060f !important}
      html.equinox-comercial-mac body>.ambience,html.equinox-comercial-mac body>.blob{display:block !important}
      html.equinox-windows-host,html.equinox-windows-host body{background:#10081c !important}
      html.equinox-windows-host .notes-window,html.equinox-windows-host .console{border-radius:0 !important}
    `;
    document.documentElement.append(style);
    if (platform === "windows") {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = window.EQUINOX_ASSET(isEquinox ? "_host/windows-equinox.css" : "_host/windows-plugins.css");
      const pin = () => { pinComercialEmbed(); };
      link.addEventListener("load", pin);
      link.addEventListener("error", pin);
      document.head.append(link);
    } else {
      pinComercialEmbed();
    }
  }

  function wireRelay() {
    const title = document.querySelector("h1");
    if (!title || title.textContent.trim() !== "RELAY") return;
    document.querySelectorAll(".pill").forEach((pill) => {
      pill.style.cursor = "pointer";
      pill.addEventListener("click", () => {
        const group = pill.parentElement;
        if (!group) return;
        group.querySelectorAll(".pill").forEach((item) => item.classList.remove("primary"));
        pill.classList.add("primary");
      });
    });
    document.querySelectorAll("button.q").forEach((button) => {
      button.addEventListener("click", () => {
        const label = button.textContent.replace(/\s+/g, " ").trim();
        showToast(label === "Export Queue"
          ? "Vista previa. Relay todavía no exporta: la cola es la pantalla comercial."
          : `${label}: opción de la pantalla de Relay.`);
      });
    });
  }

  function flush() {
    const batch = queued.splice(0);
    for (const [name, msg] of batch) dispatch(name, msg);
    seedEquinox();
    seedAbsolute();
    if (!glyphSeeded) seedGlyph();
    seedObsidian();
    if (!notesSeeded && window.AbsoluteNotes) onNotes("ready");
    mountExtraAddons();
    wireRelay();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", mountChrome);
  } else {
    mountChrome();
  }
  window.addEventListener("load", flush);
})();
